export var RankedDivisionTypes = /*#__PURE__*/ function(RankedDivisionTypes) {
    RankedDivisionTypes[RankedDivisionTypes["Grandmaster"] = 0] = "Grandmaster";
    RankedDivisionTypes[RankedDivisionTypes["Master"] = 1] = "Master";
    RankedDivisionTypes[RankedDivisionTypes["Diamond"] = 2] = "Diamond";
    RankedDivisionTypes[RankedDivisionTypes["Platinum"] = 3] = "Platinum";
    RankedDivisionTypes[RankedDivisionTypes["Gold"] = 4] = "Gold";
    RankedDivisionTypes[RankedDivisionTypes["Silver"] = 5] = "Silver";
    RankedDivisionTypes[RankedDivisionTypes["Bronze"] = 6] = "Bronze";
    RankedDivisionTypes[RankedDivisionTypes["None"] = 7] = "None";
    return RankedDivisionTypes;
}({});
export var RankedSubDivisionTypes = /*#__PURE__*/ function(RankedSubDivisionTypes) {
    RankedSubDivisionTypes[RankedSubDivisionTypes["None"] = 0] = "None";
    RankedSubDivisionTypes[RankedSubDivisionTypes["I"] = 1] = "I";
    RankedSubDivisionTypes[RankedSubDivisionTypes["II"] = 2] = "II";
    RankedSubDivisionTypes[RankedSubDivisionTypes["III"] = 3] = "III";
    RankedSubDivisionTypes[RankedSubDivisionTypes["IV"] = 4] = "IV";
    RankedSubDivisionTypes[RankedSubDivisionTypes["V"] = 5] = "V";
    return RankedSubDivisionTypes;
}({});
